// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#standard-account-register[data-v-db6b7116]{max-width:700px;margin-left:auto;margin-right:auto}#standard-account-register .cancel-btn[data-v-db6b7116],#standard-account-register .update-btn[data-v-db6b7116]{width:120px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
